import { InputDropdown } from '@artprov/design-system'
import { getHintsForField } from './nuevaSolicitud.utils'

export default function InputCAECAICAE({ formState, opcionesTipoCae, disabled, handleOnChange, clear, formErrors }) {

    return (
        <InputDropdown
            key={clear ? "limpiar" : "normal"}
            label="Código de autorización"
            name="tipoCaeCai"
            id="tipoCaeCai"
            defaultSelection={false}
            value={formState?.tipoCaeCaiSelected}
            placeholder={formState?.tipoCaeCaiSelected !== '' ? formState?.tipoCaeCaiSelected : "Seleccionar"}
            hints={getHintsForField("tipoCaeCai", formErrors)}
            position="bottom"
            disabled={disabled}
            onChange={({ value }) => {
                if (value) {
                    handleOnChange(value);
                }
            }}
            classNameContainerInput="w-[127px]"
            classNameContainer="w-[257px]"
            className="w-[257px]">
            {!clear ? opcionesTipoCae : []}
        </InputDropdown>
    )
}
